import _ from 'lodash';
import type { ChatMessageTemplateRepresentedOrganizationsHQ_chatMessageTemplateRepresentedOrganizations_organizations as RepresentedOrganizationsHQ } from '../__generated__/ChatMessageTemplateRepresentedOrganizationsHQ';
import type { TypePolicies } from '@apollo/client';
import { keyBy, uniqBy } from 'lib/apollo/cache/cache_helpers';

export const hqOrganizationRepresentativesPolicies: TypePolicies = {
  ChatMessageTemplateRepresentedOrganizationsHQ: {
    fields: {
      organizations: {
        // We get actual objects here because we are not normalizing data inside it,
        // instead we are storing the query response as is (this is preferred going forward),
        // so it is much easier to inspect objects and do the merging as needed
        merge: (
          existing: Array<Partial<RepresentedOrganizationsHQ>> = [],
          incoming: Array<Partial<RepresentedOrganizationsHQ>> | undefined
        ) => {
          // merge incoming into existing with the same uuid
          const existingByUuid = keyBy(existing, 'uuid');
          const incomingByUuid = keyBy(incoming ?? [], 'uuid');

          // notice that incoming comes first, so that we can override existing
          // make sure there's only one item per uuid
          const merged = _.merge({}, existingByUuid, incomingByUuid);
          const items = Object.values(merged);

          // unify by uuid with merging
          const itemsUniq = uniqBy(items, 'uuid');

          // we want to sort by descending sequenceId
          const itemsSorted = _.sortBy(itemsUniq, 'uuid').slice().reverse();
          return itemsSorted;
        },
      },
    },
  },
  ChatMessageTemplates: {
    keyFields: ['uuid'],
  },
  Query: {
    fields: {
      chatMessageTemplateRepresentedOrganizations: {
        // no key, all queries get cached in the same item
        keyArgs: false,
      },
    },
  },
};

export const hqChatMessageTemplatePolicies: TypePolicies = {
  ChatMessageTemplates: {
    keyFields: ['chatMessageTemplateUuid'],
  },
};
